import React, { useEffect, useMemo } from "react";

import { usePageNameContext } from "@stadium/shared/page-name-provider";
import useFetchMarketingCategories from "@hooks/use-fetch-marketing-categories";

import SearchTemplateHit from "@components/search-template-hits/single-hit";
import InstantSearchWrapper, { useInstantSearch } from "@stadium/shared/src/components/instant-search";
import TrendingHits from "@components/search-template-hits/trending-hits";

import { getCategoryId } from "@stadium/shared/src/helpers/templates-listing";
import { MOMENTS } from "@constants/routes";
import { DEFAULT_CATERGORY_SLUG } from "@constants/templates-listing";

import styles from "./main.module.scss";

const SearchTemplateHits = ({
  onTemplateSelect,
  search,
  forBanners = false,
  setSearchedHits = () => {},
  hasSearchedStore = false,
  text: searchedEntityName = "",
}) => {
  const { hits, loading } = useInstantSearch();
  const strigifiedHits = JSON.stringify(hits);
  const pageName = usePageNameContext();

  const { marketingCategories } = useFetchMarketingCategories({
    currentCategory: DEFAULT_CATERGORY_SLUG,
  });

  const defaultCategoryId = useMemo(() => {
    return getCategoryId({ categories: marketingCategories, name: DEFAULT_CATERGORY_SLUG });
  }, [marketingCategories?.length]);

  useEffect(() => {
    if (forBanners) setSearchedHits(hits);
    //Keeping hits as dependency will create a new reference for array on each keydown event as hits are live from connectHits thus causing Maximum update depth exceeded.
    //Stringifying it will check for shallow comparision, there is no need for deep comparision in this case as only store_name is being searched upon.

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [strigifiedHits, forBanners]);

  const text = (() => {
    if (searchedEntityName) return searchedEntityName;
    if (forBanners) return "banners";
    if (pageName === MOMENTS) return "moments";
    return "templates";
  })();

  const showNoSearchResults = !loading && !hasSearchedStore;

  return (
    <div className={styles.searchResultsContainer}>
      {hits.length
        ? hits.map((hit) => (
            <SearchTemplateHit
              key={hit?.id}
              hit={hit}
              onTemplateSelect={onTemplateSelect}
              forBanners={forBanners}
            />
          ))
        : showNoSearchResults && (
            <>
              <div className={styles.searchResultsMessageRow}>
                Sorry! We couldn’t find any {text} related to "{search}".
                <br />
                Here are some popular {text} you may like:
              </div>
              <div className={styles.searchResultsContentHolder}>
                <InstantSearchWrapper categoryId={defaultCategoryId}>
                  <TrendingHits
                    onTemplateSelect={onTemplateSelect}
                    forBanners={forBanners}
                    setSearchedHits={setSearchedHits}
                  />
                </InstantSearchWrapper>
              </div>
            </>
          )}
    </div>
  );
};

export default SearchTemplateHits;
